import { idpcState } from "./store";
export const idGen = (prefix = "idpc_") => () => {
    const g = idpcState();
    if (!g.idGen)
        g.idGen = {};
    if (g.idGen[prefix] === undefined)
        g.idGen[prefix] = 0;
    g.idGen[prefix] += 1;
    return `${prefix}${g.idGen[prefix]}`;
};
